<template>
  <van-calendar
  title="主页"
  :poppable="false"
  :show-confirm="false"
  :style="{ height: '100vh' }"
/>
</template>

<script>
import { Calendar } from 'vant';
export default {
  name: 'Home',
  components: {
    [Calendar.name]: Calendar
  }
}
</script>
